import { render, staticRenderFns } from "./recipient.vue?vue&type=template&id=f91c319e&scoped=true"
import script from "./recipient.vue?vue&type=script&lang=ts"
export * from "./recipient.vue?vue&type=script&lang=ts"
import style0 from "./recipient.vue?vue&type=style&index=0&id=f91c319e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91c319e",
  null
  
)

export default component.exports